import React from 'react';
import SEO from '../components/seo';
import Link from '../components/Link';

import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';

const DesignersPage = ({ pageContext, location }) => {
  const { seo = {}, title, description, designers = [] } = pageContext;

  const metaTitle = (seo && seo.metaTitle) || 'Eugenie Detroit';
  const openGraphTitle = (seo && seo.openGraphTitle) || 'Eugenie Detroit';
  const twitterTitle = (seo && seo.twitterTitle) || 'Eugenie Detroit';


  const brandsMap = ((m, a) => (
    a.forEach(designer => {
      if (!designer) return;
      let firstChar = designer.title[0].toLowerCase();
      let arr = m.get(firstChar) || [];
      if (!arr.some(d => d.slug === designer.slug)) {
        arr.push(designer);
      }
      m.set(firstChar, arr);
    }),
    m
  ))(new Map(), designers);

  const alpha = Array.from(Array(26)).map((e, i) => i + 65);
  const alphabet = alpha.map(x => String.fromCharCode(x).toLowerCase());

  const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  const hero = (title || description) && (
    <section className="page-richtext p2 pt10--lg pb10--lg bb--dark-brown">
      {title && (
        <h1 className="serif--lg serif--xl--lg pb2 pb5--lg">{title}</h1>
      )}
      {description && (
        <div className="sans--sm sans--md--md rich-text">
          <BlockContent blocks={description} serializers={richText} />
        </div>
      )}
    </section>
  );

  const designersList = designers.length > 0 && (
    <section className="df fw designers__list">
      {numbers.map(num => {
        return (
          brandsMap.get(num)?.length && (
            <aside className="designers__list-tem p2">
              <p className="serif--sm serif--lg--lg">0-9</p>
              {brandsMap.get(num)?.length && (
                <ul className="bt--dark-grey mt2 pt2 pb5 pb10--lg">
                  {brandsMap.get(num).map(designer => (
                    <li key={designer.slug}>
                      <Link
                        className="mono--md mono--lg--md uppercase block link--underline-reverse w-max"
                        key={designer.slug}
                        url={`/designers/${designer.slug}`}
                      >
                        {designer.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </aside>
          )
        );
      })}
      {alphabet.map(letter => {
        return (
          brandsMap.get(letter)?.length && (
            <aside className="designers__list-tem p2">
              <p className="serif--sm serif--lg--lg">
                {letter.toUpperCase()}
                <em>{letter}</em>
              </p>
              {brandsMap.get(letter)?.length && (
                <ul className="bt--dark-grey mt2 pt2 pb5 pb10--lg">
                  {brandsMap.get(letter).map(designer => (
                    <li key={designer.slug}>
                      <Link
                        className="mono--md mono--lg--md uppercase block link--underline-reverse w-max"
                        key={designer.slug}
                        url={`/designers/${designer.slug}`}
                      >
                        {designer.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </aside>
          )
        );
      })}
    </section>
  );

  return (
    <React.Fragment>
      <SEO
        metaTitle={metaTitle || 'Designers - Eugenie Detroit'}
        metaDescription={seo?.metaDescription}
        metaKeywords={seo?.metaKeywords}
        openGraphTitle={openGraphTitle || 'Designers - Eugenie Detroit'}
        openGraphDescription={seo?.openGraphDescription}
        openGraphImage={seo?.openGraphImage}
        twitterTitle={twitterTitle || 'Designers - Eugenie Detroit'}
        twitterDescription={seo?.twitterDescription}
        twitterImage={seo?.twitterImage}
        pathname={location.pathname}
      />
      {hero}
      {designersList}
    </React.Fragment>
  );
};

export default DesignersPage;
